import { NavLink } from 'react-router-dom';
import { type ReactNode } from 'react';
import { Avatar } from '@ics-portal/guardian';
import { useGlobalUI } from '@contexts/GlobalUiContext';
import useUser from '@hooks/useUser';
import { NavigationPath } from '@utils/getMenuContent';

export default function ProfileLink(): ReactNode {
    const user = useUser();
    const { appClassName } = useGlobalUI();
    if (!user) return null;

    const fullName = `${user.firstName} ${user.lastName}`;

    return (
        <NavLink
            to={NavigationPath.CurrentUserProfile}
            title={fullName}
            className="flex align-items-center py-2 px-3 no-underline"
        >
            <Avatar
                userName={fullName}
                showDescription={appClassName !== 'collapsed'}
                large
                colorsReverted
            />
        </NavLink>
    );
}
